"use client";

import { useLocale } from "next-intl";
import { useRouter, usePathname } from "@/i18n/navigation";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Globe } from "lucide-react";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const locales = [
	{ code: "pt-BR", label: "Português", flag: "🇧🇷" },
	{ code: "en-US", label: "English", flag: "🇺🇸" },
] as const;

export function LanguageToggle({ className = "" }: { className?: string }) {
	const locale = useLocale();
	const router = useRouter();
	const pathname = usePathname();

	const currentLocale = locales.find((l) => l.code === locale) ?? locales[0];

	const switchLocale = (newLocale: string) => {
		router.replace(pathname, { locale: newLocale });
	};

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button
					size="icon"
					variant="outline"
					className={cn(className)}
					aria-label="Change language"
				>
					<Globe className="h-[1.2rem] w-[1.2rem]" />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end">
				{locales.map((l) => (
					<DropdownMenuItem
						key={l.code}
						onClick={() => switchLocale(l.code)}
						className={cn(
							"cursor-pointer",
							locale === l.code && "bg-accent",
						)}
					>
						<span className="mr-2">{l.flag}</span>
						{l.label}
					</DropdownMenuItem>
				))}
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
